var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.5 47.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38h38V0H0v38Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 47.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3b88c3",
    d: "M37 5a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v28a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.39 22.51c.744.155 1.551.31 2.326.31 3.752 0 6.418-2.977 6.418-6.604 0-5.178-2.852-8.589-8.217-8.589-2.201 0-6.821 1.427-6.821 4.155a2.13 2.13 0 0 0 2.108 2.108c1.241 0 2.729-1.984 4.806-1.984 2.171 0 3.288 2.109 3.288 4.062 0 1.86-1.055 3.131-2.977 3.131-1.799 0-2.078-1.023-3.66-1.023-1.209 0-1.829.93-1.829 1.457 0 .404.062.713.093 1.055l.776 6.542c.34 2.418.93 2.945 2.418 2.945h7.472c1.427 0 2.263-.836 2.263-1.953 0-2.139-1.611-2.325-2.17-2.325h-5.829l-.465-3.287Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.5d5d2ab2bf0300d819d159f8e0e32f3a.svg";
export { ForwardRef as ReactComponent };